import { Box, BoxContent } from '@mm/components';
import { formattedInvoicesSelector } from '@mm/state/selectors/subscriptionSelectors';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import classNames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { compose } from 'recompose';
import { RouterComponentProps } from '../../../common/helpers/routes/interfaces';
import { SettingsRoutes } from '../../../routes/settings-routes';
import { Routes } from '../../../routes/top-level-routes';
import { getBasePath } from './BillingPanel/SubscriptionTabsArea/ActiveSubscriptionTab/helpers';
import FetchBillingData from './FetchBillingData';
import './SettingsPage.pcss';
import SettingsSidebar from './SettingsSidebar/SettingsSidebar';

type OuterProps = {};

type InnerProps = ReturnType<typeof mapStateToProps> & RouterComponentProps;

type Props = OuterProps & InnerProps;

const mapStateToProps = (state: StoreState) => ({
  company: activeCompanySelector(state),
  invoices: formattedInvoicesSelector(state),
});

const SettingsPage = (props: Props) => {
  const { company, invoices } = props;
  const location = useLocation();

  const isManageSubscriptionsPage = location.pathname.includes(
    getBasePath(SettingsRoutes.billing.manageSubscrptions.path),
  );

  return (
    <section className="settings">
      <Box className="settings__box">
        <div
          className={classNames('settings-page__content-area', {
            'settings-page__content-area-manage-page':
              isManageSubscriptionsPage,
          })}
        >
          {!isManageSubscriptionsPage && <SettingsSidebar />}
          {company && (
            <FetchBillingData>
              <BoxContent className={classNames('settings-page__box-content')}>
                <Switch>
                  <Route
                    exact
                    path={SettingsRoutes.company.path}
                    render={() => {
                      const Component = SettingsRoutes.company.component;

                      if (company && !company.editable) {
                        return <Redirect to={SettingsRoutes.users.getLink()} />;
                      }

                      return <Component />;
                    }}
                  />

                  <Route
                    exact
                    path={SettingsRoutes.billing.path}
                    render={props => {
                      const Component = SettingsRoutes.billing.component;

                      if (company && !company.editable) {
                        return <Redirect to={SettingsRoutes.users.getLink()} />;
                      }

                      return <Component {...props} />;
                    }}
                  />

                  <Route
                    exact
                    path={SettingsRoutes.billing.cancel.path}
                    render={props => {
                      const Component = SettingsRoutes.billing.cancel.component;

                      if ((company && !company.editable) || !invoices.length) {
                        return (
                          <Redirect to={SettingsRoutes.billing.getLink()} />
                        );
                      }

                      return <Component />;
                    }}
                  />

                  <Route
                    exact
                    path={SettingsRoutes.billing.manageSubscrptions.path}
                    component={
                      SettingsRoutes.billing.manageSubscrptions.component
                    }
                  />

                  <Route
                    exact
                    path={SettingsRoutes.users.path}
                    component={SettingsRoutes.users.component}
                  />
                  <Route
                    exact
                    path={SettingsRoutes.affiliates.path}
                    component={SettingsRoutes.affiliates.component}
                  />
                  <Route
                    exact
                    path={SettingsRoutes.myAccount.path}
                    component={SettingsRoutes.myAccount.component}
                  />

                  <Route
                    exact
                    path={SettingsRoutes.notifications.path}
                    component={SettingsRoutes.notifications.component}
                  />

                  <Redirect
                    from={Routes.settings.path}
                    to={SettingsRoutes.billing.getLink()}
                  />
                </Switch>
              </BoxContent>
            </FetchBillingData>
          )}
        </div>
      </Box>
    </section>
  );
};

const enhance = compose<InnerProps, OuterProps>(connect(mapStateToProps));

export default enhance(SettingsPage);
